import HeaderBar from "./HeaderBar";
import { useTheme } from "./ThemeContext";
import { Disclosure } from '@headlessui/react';
import { ChevronUpIcon } from '@heroicons/react/20/solid';
import '../../styles/style.css';
import { useData } from "./MemberData";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import '../../styles/style.css';

function InfoPage() {
    const { theme } = useTheme();
    const { membersData } = useData();
    const [myDiscordID, setMyDiscordID] = useState('');

    useEffect(() => {
        setMyDiscordID(Cookies.get('myDiscordID') || '');    
    }, []);

    const getRank = () => {
        const findMember = membersData.find((m) => m.discordID === myDiscordID);
        if (findMember) {
            return findMember.grade;
        }
    }

    const rankInfo = {
        "Asistent-Medical": `
            <strong>CODURI DE COMUNICARE</strong><br />
            <ul>
                <li><strong>10-0</strong>: Focuri arme / Pericol - Ex.: "M-101, 10-0, 10-20 [locație]"</li>
                <li><strong>10-1</strong>: Am preluat apelul precedent - Ex.: "M-101, 10-1"</li>
                <li><strong>10-4</strong>: Recepționat - Ex.: "M-001 mă recepționați? Răspuns: M-101, 10-4"</li>
                <li><strong>10-9</strong>: Repetă - Ex.: "M-101, 10-9 te rog"</li>
                <li><strong>10-11</strong>: Apel fals - Ex.: "M-101, 10-11"</li>
                <li><strong>10-13</strong>: Preluare BK4 / Cod 4 - Ex.: "M-101, 10-13"</li>
                <li><strong>10-20</strong>: Locație curentă - Ex.: "M-101, 10-20 [locație]"</li>
                <li><strong>10-33</strong>: Liniște pe stație - Ex.: "M-101, 10-33!"</li>
                <li><strong>10-39</strong>: Regrupare - Ex.: "10-39, 10-20 HELIPAD AVEȚI 5 MINUTE"</li>
                <li><strong>10-41</strong>: On-duty - Ex.: "M-101, 10-41"</li>
                <li><strong>10-42</strong>: Off-duty - Ex.: "M-101, 10-42"</li>
                <li><strong>10-50</strong>: Accident - Ex.: "M-101, am făcut un 10-50 major"</li>
                <li><strong>10-55</strong>: Apel soluționat - Ex.: "M-101, 10-55"</li>
                <li><strong>10-76</strong>: În drum spre - Ex.: "M-101, 10-76 ultima solicitare"</li>
                <li><strong>10-78</strong>: Am nevoie de echipaj adițional - Ex.: "M-101, 10-78 la următorul cod"</li>
                <li><strong>10-95</strong>: Pacient în custodie (conștient/inconștient) - Ex.: "M-101, am un 10-95 conștient"</li>
                <li><strong>10-100</strong>: Închid stația - Ex.: "M-101, 10-100 Medicina Muncii - motivul"</li>
            </ul><br />
            <strong>CODURI DE ASISTENȚĂ</strong><br />
            <ul>
                <li><strong>Cod 0</strong>: Situații extrem de grave (bătăi, jafuri, infracțiuni majore).</li>
                <li><strong>Cod 4</strong>: Asistență pentru colegi sau civili căzuți.</li>
                <li><strong>Cod 6</strong>: Zona este liberă de acțiune pentru medici.</li>
                <li><strong>Cod 78</strong>: Solicitare pentru echipaj adițional.</li>
            </ul><br />
            <strong>IMPORTANT</strong><br />
            <p>
                <em>Răspunderea unui polițist</em><br />
                Polițist pe stație: "531 Cadet Tristan Maroc, am și eu nevoie de un echipaj la următorul COD 4!"<br />
                Medic pe stație: "M-101 Medic Primar, Shiva Lazzari ajunge un echipaj imediat la COD!"
            </p>
            <p><br />
                <strong>Reguli:</strong><br />
                - Codurile <strong>10-41, 10-42, 10-100</strong> se anunță doar pe dispecer (/M).<br />
                - La BK răspunde cel mai mare grad activ.<br />
                - Dacă mergi cu un coleg în patrulă, anunți: "M-101 +1".<br />
                - La codul <strong>0</strong> se merge fără sirene!
            </p>
        `,
        "Medic-Stagiar": `
            <strong>CERTIFICARE SMULS</strong><br />
            Medicamente și Echipamente<br />
            <strong>Pașii unei Descarcerări</strong><br />
            1.	Securizarea zonei de lucru: Verificarea scurgerilor de combustibil, cablurilor electrice sau altor pericole.<br />
            2.	Pregătirea echipamentului: Scoaterea echipamentului necesar din autospecială (foarfecă hidraulică, clește, fierăstrău pneumatic etc.).<br />
            3.	Analiza daunelor: Evaluarea completă a vehiculului și identificarea zonelor afectate pentru a decide metoda de intervenție.<br />
            4.	Stabilirea numărului de victime: Identificarea și confirmarea numărului de persoane încarcerate.<br />
            5.	Deconectarea bateriei: Decuplarea cablurilor bateriei pentru siguranță, fie manual, fie folosind patentul.<br />
            6.	Tăierea parbrizului/lunetei: Utilizarea fierăstrăului pneumatic pentru a facilita accesul și verificarea stării victimei.<br />
            7.	Imobilizarea victimei: Susținerea capului victimei și montarea vestei de extracție (tip KED).<br />
            8.	Montarea gulerului cervical: Ajustarea și fixarea gulerului pentru a proteja coloana cervicală.<br />
            9.	Stabilirea metodei de descarcerare: Alegerea tehnicii adecvate (decopertarea plafonului sau a portierei) pentru a crea spațiu necesar echipei medicale și victimei.<br />
            ________________________________________<br />
            <br /><strong>Decopertarea unei Portiere</strong><br />
            1.	Spargerea geamului portierei: Utilizarea uneltelor din autospecială (ex. ciocan special).<br />
            2.	Conectarea cleștelui hidraulic: Atașarea acestuia la alimentarea cu compresor a autospecialei.<br />
            3.	Fixarea cleștelui: Poziționarea acestuia între ușă și aripa autoturismului.<br />
            4.	Îndepărtarea părților caroseriei: Activarea cleștelui hidraulic pentru separarea părților apăsând butonul.<br />
            5.	Tăierea balamalelor: Schimbarea modului de operare al cleștelui, fixarea acestuia pe balamale și tăierea lor.<br />
            6.	Îndepărtarea portierei: Retragerea ușii cu grijă și verificarea imediată a stării victimei.<br />
            ________________________________________<br />
            <br /><strong>Îngrijirea Victimei pe Parcursul Descarcerării</strong><br />
            1.	Monitorizarea stării victimei: Evaluarea constantă a semnelor vitale și a stării generale.<br />
            2.	Pregătirea echipamentului: Scoaterea și pregătirea vestei de extracție KED și a gulerului cervical.<br />
            3.	Imobilizarea victimei: Montarea vestei de extracție și ajustarea acesteia, urmată de aplicarea gulerului cervical.<br />
            4.	Extracția victimei: Scoaterea cu grijă a victimei din autoturism folosind echipamentul de imobilizare.<br />
            5.	Verificarea stării victimei: Evaluarea leziunilor și acordarea primului ajutor, dacă este necesar.<br />
            ________________________________________ <br />
            <br /><strong>Echipamente de Descarcerare și Medicamente Necesare</strong><br />
            •	Clește hidraulic: Utilizat la depărtarea a două părți de caroserie pe o lungime mică; folosit și la tăierea caroseriei.<br />
            •	Foarfeca hidraulică: Folosită la strângerea caroseriei pentru a facilita depărtarea.<br />
            •	Gheara mecanică: Utilizată pentru legarea unei părți de caroserie de un obiect fix pentru a o desprinde.<br />
            •	Fierăstrău pneumatic: Utilizat la tăierea parbrizului sau lunetei.<br />
            •	Ked de extracție: Folosit pentru imobilizarea coloanei vertebrale (are forma de vestă).<br />
            •	Compresor: Utilizat pentru comprimarea aerului pentru echipamente pneumatice.<br />
            •	Furtun de aer comprimat: Conectează echipamentele pneumatice la compresor.<br />
            •	Triunghiuri de blocare: Se plasează sub roți pentru imobilizarea vehiculului.<br />
            •	Proiectoare: Utilizate pentru iluminarea scenei.<br />
            •	Extinctor: Folosit pentru stingerea incendiilor.<br />
            •	Lanțuri: Utilizate pentru asigurarea vehiculului.<br />
            •	Patent: Folosit pentru tăierea cablurilor bateriei auto.<br />
            
            <br /><strong>Medicamente Necesare - Categorii și Utilizare</strong><br />
            •	Dureri de cap: Nurofen, Antinevralgic, Parasinus.<br />
            •	Dureri de burtă: No-Spa, Dicarbocalm.<br />
            •	Răceală: Nurofen răceală și gripă, Parasinus, Paracetamol.<br />
            •	Dureri de gât: Strepsils, Decasept.<br />
            •	Inflamații: Voltaren, antiinflamatoare.<br />
            •	Deficit de vitamine/minerale: Pastile cu vitamine/calciu/magneziu (ex: fiolă de 10 comprimate cu 50mg).<br />
            •	Arsuri: Dermazin (cremă), Regen Agen (cremă), pătură de arși pe durata transportului.<br />
            •	Dureri puternice/insuportabile: Morfină (injectabil intravenos, 0,25-0,5 ml).<br />
            •	Prevenirea infecțiilor/Antibiotice: Augmentin, Tetraciclină.<br />
            •	Stop cardio-respirator: Atropină (3 mg intravenos), Adrenalină (1 ml soluție injectabilă în 10 ml ser fiziologic).<br />
            •	Anemie: Maltofer (mastecabil).<br />
            •	Alergii/Șoc anafilactic: Hidrocortizon (100-500 mg intravenos dizolvat în perfuzie), Adrenalină (1 ml soluție injectabilă în 10 ml ser fiziologic).<br />
            •	Curățarea rănii: Betadină, Apă oxigenată.<br />
            •	Boli articulare reumatice: Diclofenac Sodic.<br />
            •	Anestezie: Xilină (anestezic local), Tetracaină (rahianestezie), Propofol, Ketamină (anestezie generală).<br />
        `,
        "Medic-Rezident": `
            <strong>CERTIFICARE PILOT</strong>
            <h4>Cerintele Obligatorii pentru obtinerea certificatului</h4>
            <ul>
                <li>Licenta de Pilot</li>
                <li>Cunoasterea regulamentului al serverului cat si regulament licenta pilot</li>
                <li>Cunoasterea cladirilor de la Banca Pacific</li>
                <li>Cunoasterea Locatiilor de Jaf cat si de rapire al intregului oras</li>
                <li>Detinerea Certificatului S.M.U.L.S in departament</li>
                <li>Aveti voie sa aterizati cu heli in intersectiile din oras: poduri, strada, autostrazi, parcari masini DOAR IN SITUATII CRITICE ADICA LA BK URI</li>
                <li>NU aveti voie sa pilotati heli singuri (DOAR CAND ALIMENTATI)</li>
                <li>AVETI VOIE SA PILOTATI SINGUR DOAR CU APROBAREA CONDUCERII</li>
                <li>Elicopterul S.M.U.L.S este dotat cu 4 locuri, echipajul heli fiind format din PILOT-CO-PILOT, MEDIC DE INTERVENTIE-(PACIENT)</li>
            </ul>
            <br />
            <h4>URCAREA PACIENTULUI IN HELICOPTER</h4>
            <pre>
                /me deschide carlinga aeronavei
                /me introduce targa in locul acesteia de siguranta
                /me conecteaza pacientul la aparatele aeronavei pentru a monitoriza semnele vitale
                /me inchide usa aeronavei
            </pre>
            <p><strong>CALIFICAREA CERTIFICATULUI PILOT AL DEPARTAMENTULUI CONSTA INTR-UN TEST PRACTIC</strong></p><br />
            <strong>CERTIFICAT MOTO</strong>

            <p><strong>!!! Cooldown este de 5 zile !!!</strong></p><br />
            <ul>
                <li>Este obligatoriu detinerea certificatului S.M.U.L.S a departamentului</li>
                <li>Gradul minim necesar este de Medic-Rezident [MR]+</li>
                <li>Cunoasterea generala a orasului (REGULAMENT SERVER)</li>
                <li>Este strict interzis sa aveti pasageri pe motor</li>
                <li>Este strict interzis sa faceti pit-stop cu motorul</li>
                <li>Este strict interzis sa sariti pe munti cu motorul</li>
                <li>Este strict interzis sa mergeti pe o roata cu motorul</li>
                <li>Este strict interzis sa schimbati jantele la motor</li>
                <li>Este strict interzis sa folositi motorul fara a purta o casca</li>
                <li>Este strict interzis sa folositi motorul pe timp de ploaie</li>
                <li>Este obligatoriu sa aveti minim 3 truse de reparatii la voi</li>
                <li>Se poate folosi un singur motor la 5 cadre medicale pe tura (Exceptie face conducerea)</li>
                <li>Personalul S.M.U.L.S cu gradul cel mai mare are prioritate la folosirea motorului (I.S.U.L.S nu are prioritate)</li>
                <li>In cazul in care pacientul doreste transport la spital veti cere un echipaj aditional care sa vina la locatia voastra (BK 78)</li>
            </ul>
<br />
            <h4>RP CERTIFICARE MOTO</h4>
            <pre>
    /me examineaza pacient
    /me verifica starea de constienta
    /me ii verifica respiratia prin metoda PAS
    /me observa ca respira
    /me il pune in pozitia de siguranta (ii da trusa)
    /me asteapta sa asigure vine
            </pre>

            <p><strong>!!! Calificarea MOTO a departamentului consta intr-un test practic !!!</strong></p>
        `,
        "Medic-Specialist": "",
        "Medic-Primar": "",
        "Medic-Chirurg": "",
        "Medic-Inspector": "",
        "Director-Adjunct": "",
        "Director-General": ""
    };
    

    return (
        <div className={`${theme} w-full h-full`}>
            <HeaderBar currentPage="INFO Utile"/>
            <div className="w-full h-[87%]">
                <div className="w-[99%] flex flex-col items-center h-full rounded-2xl overflow-y-scroll">
                    <Disclosure as="div" className="mt-2 w-full">
                        {({ open }) => (
                            <>
                                <Disclosure.Button className="flex items-center w-full h-[5vh] justify-between rounded-lg bg-white dark:bg-[#f9731675] px-4 py-2 text-left text-sm font-medium hover:bg-orange-600 focus:outline-none focus-visible:ring focus-visible:ring-orange-600/75">
                                    <span className="textBold text-[1.1vw] text-black dark:text-white">Introducere</span>
                                    <ChevronUpIcon
                                        className={`${
                                            open ? 'rotate-180 transform' : ''
                                        } h-5 w-5 text-black dark:text-white`}
                                    />
                                </Disclosure.Button>
                                <Disclosure.Panel className="bg-white dark:bg-[#323232c1] textMedium px-4 pb-2 pt-4 text-sm text-black dark:text-white textMedium">
                                    <span className="textMedium text-[0.8vw] text-black dark:text-white">
                                        <span className="textBold text-[0.9vw]">Medicii au obligația de a trata pe toată lumea</span><br />
                                        Trebuie să fii serios și să te comporți ca atare. Nu vei primi seriozitate până nu oferi seriozitate.	<br />
                                        Ai grijă să ai mereu bandaje & truse de prim-ajutor la tine.	<br />
                                        Ai grijă să ai mereu 3 truse de reparatii & 2-3 canistre cu combustibil la tine.	<br />
                                        Nu te bate, nu țipa, încearcă să folosești un ton cât mai calm, în special atunci când ești în spital.	<br />
                                        Nu face glume proaste, care pot ofensa și păstrează un limbaj adecvat atât IC cât și OOC.	<br />
                                        Evită orice conflict! Pentru deranjamente, contactează un admin sau pe cei responsabili de facțiune.	<br />
                                        Înainte de a face un roleplay lung, nu uita să-i dai ''REANIMEAZĂ'' rănitului.	<br />
                                        Fiți siguri că nu v-a scăpat nimic din regulament, dacă nu îl cunoașteți la perfecție sunteți vulnerabili.	<br />
                                        Dacă cineva este agresiv sau face troll, filmați și trimiteți către lider sau faceți ticket pe Discord.	<br />
                                        Nu faceți NO - FEAR. Oriunde vi se pare că există amenințări sau sunteți atacați chemați poliția și nu interveniți. Dacă nu a fost roleplay, /ticket sau un ticket pe DISCORD.	<br />
                                        Nu vă stresați când cineva încearcă să va grăbească / să vă spună ce aveți de făcut. Procedați exact cum sunteți instruiți.	<br />
                                        Evită să fii ignorant/neinteresat de facțiune și de colegii tai.	<br />
                                        Fiți rezonabili, toleranți cu restul membrilor, împrieteniți-vă, faceți roleplay și simțiți-va bine.	<br />
                                        <br />
                                        <span className="textBold text-[0.9vw]">Viceroy</span><br />
                                        Spitalul cu cele mai multe opțiuni, aveți camere de RMN / radiografie , toalete, saloane private / comune, mai multe săli de operație și birouri.<br />
                                        <br />
                                        <span className="textBold text-[0.9vw]">Spitalele din zonele rurale - Paleto Bay și Sandy Shores</span><br />
                                        Dispun doar de 6 paturi, însă la fel ca și cele din oraș, acestea au recepții, garaje (inclusiv elicopter), loc de unde să iți iei uniformă și echipament.	<br />
                                        Aveți la dispoziție destule dotări pentru a vă desfășura roleplay-ul în condiții normale.	<br />
                                        Cei ce au nevoie de îngrijiri în zonele acestea vor fi nevoiți să aștepte mai mult și nu au dreptul să vă grăbească.	<br />
                                        DUTY-ul îl poți lua din spitalul orașului impreuna cu echipamentul și uniforma.	<br />
                                        <br />
                                        1. Uniformă Asistent - Se va folosii de către Asistenții-Medicali care stau în spital pentru întâmpinarea pacienților din cadrul spitalului.	<br />
                                        2. Uniformă S.M.U.L.S 1/2 - Se va folosii de către MR+ va lua autospecialele S.M.U.L.S când este nevoie de îngrijiri adiționale și este un accident rutier iar persoanele din mașină sunt încarcerate, aici intervine echipaj S.M.U.L.S descarcerare.	<br />
                                        3. Halatul va fi folosit de gradele mari [MR / MS / MP / MC / MI / DA / DG] iar ei se vor ocupa de supravegherea asistenților-medicali ce sunt puși să stea în spital / la ghișeu pentru întâmpinarea pacienților.	<br />
                                        4. Persoanele [MR+] ce trebuie să susțină o operație pot folosi Halatul iar asistentul medical se folosește tot de uniforma lui normală!	<br />
                                        5. Atunci când un grad mare are o operație se poate lua un singur asistent-medical aflat în spital la operație pentru a-l ajuta.	<br />
                                        6. Atunci când un Asistent-Medical iese din spital prin rotație și merge pe teren va putea lua uniforma de Ambulanță 1/2.	<br />
                                        <br />
                                        <span className="textBold text-[0.9vw]">EXTRA</span><br />
                                        ATENȚIE! Verifică in K daca ai meniul "Spitalul Los Santos" să ai mereu DUTY-ul cand esti pe tura!	<br />
                                        Este interzisă fraudarea pontajului, în cazul în care, în urma unei verificări, reiese că fentati pontajul acesta este anulat integral + amenda.	<br />
                                        Status ON-DUTY atunci când ești OFF-DUTY se pedepsește cu BAN TEMPORAR 30 ZILE	<br />
                                    </span>
                                </Disclosure.Panel>
                            </>
                        )}
                    </Disclosure>
                    <Disclosure as="div" className="mt-2 w-full">
                        {({ open }) => (
                            <>
                                <Disclosure.Button className="flex items-center w-full h-[5vh] justify-between rounded-lg bg-white dark:bg-[#f9731675] px-4 py-2 text-left text-sm font-medium hover:bg-orange-600 focus:outline-none focus-visible:ring focus-visible:ring-orange-600/75">
                                    <span className="textBold text-[1.1vw] text-black dark:text-white">Invata pentru teste</span>
                                    <ChevronUpIcon
                                        className={`${
                                            open ? 'rotate-180 transform' : ''
                                        } h-5 w-5 text-black dark:text-white`}
                                    />
                                </Disclosure.Button>
                                <Disclosure.Panel className="bg-white dark:bg-[#323232c1] text-black dark:text-white textMedium px-4 pb-2 pt-4 text-sm">
                                    <span className="textMedium text-[0.8vw] text-black dark:text-white">
                                        {getRank() === "Asistent-Medical" && (
                                            <div dangerouslySetInnerHTML={{ __html: rankInfo["Asistent-Medical"] }} />
                                        )}

                                        {getRank() === "Medic-Stagiar" && (
                                            <>
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Asistent-Medical"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Stagiar"] }} /><br />
                                            </>
                                        )}

                                        {getRank() === "Medic-Rezident" && (
                                            <>
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Asistent-Medical"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Stagiar"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Rezident"] }} /><br />
                                            </>
                                        )}

                                        {getRank() === "Medic-Specialist" && (
                                            <>
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Asistent-Medical"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Stagiar"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Rezident"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Specialist"] }} /><br />
                                            </>
                                        )}

                                        {getRank() === "Medic-Primar" && (
                                            <>
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Asistent-Medical"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Stagiar"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Rezident"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Specialist"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Primar"] }} /><br />
                                            </>
                                        )}

                                        {getRank() === "Medic-Chirurg" && (
                                            <>
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Asistent-Medical"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Stagiar"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Rezident"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Specialist"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Primar"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Chirurg"] }} /><br />
                                            </>
                                        )}

                                        {getRank() === "Medic-Inspector" && (
                                            <>
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Asistent-Medical"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Stagiar"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Rezident"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Specialist"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Primar"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Chirurg"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Inspector"] }} /><br />
                                            </>
                                        )}

                                        {getRank() === "Director-Adjunct" && (
                                            <>
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Asistent-Medical"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Stagiar"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Rezident"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Specialist"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Primar"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Chirurg"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Inspector"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Director-Adjunct"] }} /><br />
                                            </>
                                        )}

                                        {getRank() === "Director-General" && (
                                            <>
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Asistent-Medical"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Stagiar"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Rezident"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Specialist"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Primar"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Chirurg"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Medic-Inspector"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Director-Adjunct"] }} /><br />
                                                <div dangerouslySetInnerHTML={{ __html: rankInfo["Director-General"] }} /><br />
                                            </>
                                        )}
                                    </span>
                                </Disclosure.Panel>
                            </>
                        )}
                    </Disclosure>
                    <Disclosure as="div" className="mt-2 w-full">
                        {({ open }) => (
                            <>
                                <Disclosure.Button className="flex items-center w-full h-[5vh] justify-between rounded-lg bg-white dark:bg-[#f9731675] px-4 py-2 text-left text-sm font-medium hover:bg-orange-600 focus:outline-none focus-visible:ring focus-visible:ring-orange-600/75">
                                    <span className="textBold text-[1.1vw] text-black dark:text-white">Criterii Avansare in GRAD</span>
                                    <ChevronUpIcon
                                        className={`${
                                            open ? 'rotate-180 transform' : ''
                                        } h-5 w-5 text-black dark:text-white`}
                                    />
                                </Disclosure.Button>
                                <Disclosure.Panel className="bg-white dark:bg-[#323232c1] textMedium px-4 pb-2 pt-4 text-sm">
                                    <span className="textMedium text-[0.8vw] text-black dark:text-white">
                                        <span className="textBold text-[0.9vw]">ASISTENT - STAGIAR *up</span> <br />
                                        - Ca si Asistent Medical pentru UP vei avea nevoie de certificatele : Radio , BLS, Regluament si 1 Antrenament JAF . <br />
                                        MINIM 120 de minute pe zi timp de o saptamana. <br />
                                        <br /><span className="textBold text-[0.9vw] pt-2">ASISTENT - MEDIC REZIDENT *double up</span> <br />
                                        - Pentru Double-UP vei avea nevoie de 2100 de minute + toate Certificatele de mai sus.    <br />
                                        <br /><span className="textBold text-[0.9vw] pt-2">MEDIC STAGIAR - MEDIC REZIDENT</span> <br />
                                        - Pentru avansare de la Medic Stagiar la Medic Rezident aveti nevoie de 2 saptamani cu pontaj pe verde + certificatul S.M.U.L.S , 1 Control la M.M.L.S si un Antrenament Jaf IC <br />
                                        <br /><span className="textBold text-[0.9vw] pt-2">MEDIC REZIDENT - MEDIC SPECIALIST</span> <br />
                                        - Pentru avansare de la Medic Rezident la Medic Specialist aveti nevoie de 3 Saptamani cu pontaj pe verde + Rezidentiat .    <br />                                              
                                        <br /><span className="textBold text-[0.9vw] pt-2">MEDIC SPECIALIST - MEDIC PRIMAR</span> <br />
                                        - Acest up este unul mai special  , acesta se ia strict pe activitatea si implicarea voastra in departamentul medical
                                    </span>
                                </Disclosure.Panel>
                            </>
                        )}
                    </Disclosure>
                    <Disclosure as="div" className="mt-2 w-full">
                        {({ open }) => (
                            <>
                                <Disclosure.Button className="flex items-center w-full h-[5vh] justify-between rounded-lg bg-white dark:bg-[#f9731675] px-4 py-2 text-left text-sm font-medium hover:bg-orange-600 focus:outline-none focus-visible:ring focus-visible:ring-orange-600/75">
                                    <span className="textBold text-[1.1vw] text-black dark:text-white">Intrare in Departament</span>
                                    <ChevronUpIcon
                                        className={`${
                                            open ? 'rotate-180 transform' : ''
                                        } h-5 w-5 text-black dark:text-white`}
                                    />
                                </Disclosure.Button>
                                <Disclosure.Panel className="bg-white dark:bg-[#323232c1] textMedium px-4 pb-2 pt-4 text-sm text-black dark:text-white textMedium">
                                    <span className="textMedium text-[0.8vw] text-black dark:text-white">
                                        <span className="textBold text-[0.9vw]">REINTEGRARE</span>  <br />
                                        -Fost grad de 300 si 200 reintra ca si 400 , au dreptul la reintegrare pana la 4 luni de le DEMISIE. <br />
                                        -Fost grad de 100 si 200 reintra ca si 300 , au dreptul la reintegrare pana la 4 luni de le DEMISIE. <br />
                                        -Fostele grade de CONDUCERE vor fi reintegrați ca si 200 pot beneficia de reintegrare în maxim 2 luni o singură dată și se pot reintegra și după 2 luni pana la 4 luni, dar cu beneficiile gradelor de 300. <br />
                                        -Cei care vin prin reintegrare au obligatia de a obtine toate certificatele in prima zi. <br />
                                        <br /><span className="textBold text-[0.9vw]">TRANSFER</span> <br />
                                        -Agent Paza [AGP] - va primi in urma transferului, gradul de ASISTENT MEDICAL. <br />
                                        -Cadet [CD] - va primi in urma transferului, gradul de ASISTENT MEDICAL. <br />
                                        -Agent [AG] - va primi in urma transferului, gradul de MEDIC STAGIAR. <br />
                                        -Agent Principal + [AP+] - va primi in urma transferului, gradul de MEDIC REZIDENT. <br />
                                        -Gradele CONDUCERII IPJ - vor primi in urma transferului, gradul de MEDIC REZIDENT + AVANSARE MAI RAPIDA <br />
                                    </span>
                                </Disclosure.Panel>
                            </>
                        )}
                    </Disclosure>
                    <Disclosure as="div" className="mt-2 w-full">
                        {({ open }) => (
                            <>
                                <Disclosure.Button className="flex items-center w-full h-[5vh] justify-between rounded-lg bg-white dark:bg-[#f9731675] px-4 py-2 text-left text-sm font-medium hover:bg-orange-600 focus:outline-none focus-visible:ring focus-visible:ring-orange-600/75">
                                    <span className="textBold text-[1.1vw] text-black dark:text-white">Masini Departament</span>
                                    <ChevronUpIcon
                                        className={`${
                                            open ? 'rotate-180 transform' : ''
                                        } h-5 w-5 text-black dark:text-white`}
                                    />
                                </Disclosure.Button>
                                <Disclosure.Panel className="bg-white dark:bg-[#323232c1] textMedium px-4 pb-2 pt-4 text-sm text-black dark:text-white textMedium">
                                    <span className="textMedium text-[0.8vw] text-black dark:text-white">
                                        <span className="textBold text-[0.9vw]">ASISTENT MEDICAL</span> - BRAVADO AMBULANCE, VAPID SPEEDO<br /><br />
                                        <span className="textBold text-[0.9vw]">MEDIC STAGIAR</span> - BRAVADO AMBULANCE, VAPID SPEEDO, DECLASSE GRANGER, BRUTE AMBULANCE, DUNDREAY STALKER, BRAVADO GRESLEY<br /><br />
                                        <span className="textBold text-[0.9vw]">MEDIC REZIDENT</span> - BRUTE AMBULANCE, BRAVADO AMBULANCE, VAPID SPEEDO, DECLASSE GRANGER, DUNDREAY STALKER, GALLIVANTER BALLER, DUNDREARY LANDSTALKER, BRAVADO GRESLEY<br /><br />
                                        <span className="textBold text-[0.9vw]">MEDIC SPECIALIST</span> - BRUTE AMBULANCE, BRAVADO AMBULANCE, VAPID SPEEDO, DECLASSE GRANGER, DUNDREAY STALKER, GALLIVANTER BALLER, DUNDREARY LANDSTALKER, BRAVADO GRESLEY, BUCKINGHAM SWIFT<br /><br />
                                        <span className="textBold text-[0.9vw]">MEDIC PRIMAR</span> - BRUTE AMBULANCE, BRAVADO AMBULANCE, VAPID SPEEDO, DECLASSE GRANGER, DUNDREAY STALKER, GALLIVANTER BALLER, DUNDREARY LANDSTALKER, BRAVADO GRESLEY, BUCKINGHAM SWIFT<br /><br />
                                        <span className="textBold text-[0.9vw]">ISULS</span> - PFISTER COMET, VAPID CARACARA, BRAVADO BUFFALO STX, DMLS RATCHET, BUCKINGHAM SUPERVOLITO, BUCKINGHAM SWIFT<br /><br />
                                        <span className="textBold text-[0.9vw]">CONDUCERE SECUNDA</span> - TOATE MASINILE + ISULS<br /><br />
                                        <span className="textBold text-[0.9vw]">CONDUCERE</span> - CONDUCERE SECUNDA + ISULS<br /><br />
                                    </span>
                                </Disclosure.Panel>
                            </>
                        )}
                    </Disclosure>
                    <Disclosure as="div" className="mt-2 w-full">
                        {({ open }) => (
                            <>
                                <Disclosure.Button className="flex items-center w-full h-[5vh] justify-between rounded-lg bg-white dark:bg-[#f9731675] px-4 py-2 text-left text-sm font-medium hover:bg-orange-600 focus:outline-none focus-visible:ring focus-visible:ring-orange-600/75">
                                    <span className="textBold text-[1.1vw] text-black dark:text-white">Plati Cooldown</span>
                                    <ChevronUpIcon
                                        className={`${
                                            open ? 'rotate-180 transform' : ''
                                        } h-5 w-5 text-black dark:text-white`}
                                    />
                                </Disclosure.Button>
                                <Disclosure.Panel className="bg-white dark:bg-[#323232c1] textMedium px-4 pb-2 pt-4 text-sm text-black dark:text-white textMedium">
                                    <span className="textMedium text-[0.8vw] text-black dark:text-white">
                                        <span className="textBold text-[0.9vw]">Plati Cooldown</span> <br />
                                            RADIO - 25K/ZI <br />
                                            BLS - 30K/ZI <br />
                                            SMULS - 30K/ZI <br />
                                            PILOT - 30K/ZI <br />
                                            MOTO - 25K/ZI<br />
                                            REZIDENTIAT - 35K/ZI<br />
                                        <br />
                                        <span className="textBold text-[0.9vw]">COOLDOWN</span> <br />
                                            RADIO - 3 zile <br />
                                            BLS - 3 zile <br />
                                            SMULS - 5 zile <br />
                                            PILOT - 5 zile <br />
                                            MOTO - 5 zile <br />
                                            REZIDENTIAT - 5 zile <br />
                                    </span>
                                </Disclosure.Panel>
                            </>
                        )}
                    </Disclosure>
                    <Disclosure as="div" className="mt-2 w-full">
                        {({ open }) => (
                            <>
                                <Disclosure.Button className="flex items-center w-full h-[5vh] justify-between rounded-lg bg-white dark:bg-[#f9731675] px-4 py-2 text-left text-sm font-medium hover:bg-orange-600 focus:outline-none focus-visible:ring focus-visible:ring-orange-600/75">
                                    <span className="textBold text-[1.1vw] text-black dark:text-white">Info Teste</span>
                                    <ChevronUpIcon
                                        className={`${
                                            open ? 'rotate-180 transform' : ''
                                        } h-5 w-5 text-black dark:text-white`}
                                    />
                                </Disclosure.Button>
                                <Disclosure.Panel className="bg-white dark:bg-[#323232c1] textMedium px-4 pb-2 pt-4 text-sm text-black dark:text-white textMedium">
                                    <span className="textMedium text-[0.8vw] text-black dark:text-white">
                                        <span className="textBold text-[0.9vw]">Regulament</span> - Primul test din departament, trebuie cunoscut regulamentul intern <br />
                                        <span className="textBold text-[0.9vw]">Radio</span> - Se poate da din prima zi in departament ,trebuie cunoscute codurile radio <br />
                                        <span className="textBold text-[0.9vw]">BLS</span> - Se poate da din a 3 a zi in departament + 240 minute | Cunoasterea medicamentelor,echipament prim-ajutor si Cert.BLS(Ghid) <br />
                                        <span className="textBold text-[0.9vw]">S.M.U.L.S</span> - Minim grad 400+,Licenta Navala | Cunoasterea medicamentelor,echipament descarcerare,Cert.S.M.U.L.S pozitii si locatii jaf(Ghid) <br />
                                        <span className="textBold text-[0.9vw]">PILOT</span> - Minim 300+,Licenta Pilot,S.M.U.L.S | Cunoasterea regulamentului de la licenta+server,locatii si pozitii jaf <br />
                                        <span className="textBold text-[0.9vw]">MOTO</span> - Minim 300+,S.M.U.L.S, Permis categ. A | Cunoasterea regulamentului server-ului <br />
                                        <span className="textBold text-[0.9vw]">Rezidentiat</span> - OBLIGATORIU PT AVANSAREA IN GRAD (300 -&gt; 200) | Cunoastere Rp. Operatii (Ghid), Medicamente/echipamente<br />
                                    </span>
                                </Disclosure.Panel>
                            </>
                        )}
                    </Disclosure>
                    <Disclosure as="div" className="mt-2 w-full">
                        {({ open }) => (
                            <>
                                <Disclosure.Button className="flex items-center w-full h-[5vh] justify-between rounded-lg bg-white dark:bg-[#f9731675] px-4 py-2 text-left text-sm font-medium hover:bg-orange-600 focus:outline-none focus-visible:ring focus-visible:ring-orange-600/75">
                                    <span className="textBold text-[1.1vw] text-black dark:text-white">Extra</span>
                                    <ChevronUpIcon
                                        className={`${
                                            open ? 'rotate-180 transform' : ''
                                        } h-5 w-5 text-black dark:text-white`}
                                    />
                                </Disclosure.Button>
                                <Disclosure.Panel className="bg-white dark:bg-[#323232c1] textMedium px-4 pb-2 pt-4 text-sm text-black dark:text-white textMedium">
                                    <span className="textMedium text-[0.8vw] text-black dark:text-white">
                                        Aveti dreptul la 14 zile CONCEDIU o data la 4 LUNI ,cu aprobare speciala de la M-001 se pot  acorda zile suplimentare <br />
                                        CONCEDIILE se ACCEPTA o data la 2 zile! <br />
                                        NU SE ACCEPTA CONCEDIILE CARE SUNT TRIMISE DUPA CE INCEPE PERIOADA RESPECTIVA! <br />
                                        NU PUTETI BENEFICIA IN PRIMELE 2 SAPTAMANI DE CONCEDIU , decat cu aprobare de la M-001. <br />
                                        PUTETI PLATI CATE ZILE DORITI PENTRU FIECARE TEST FARA A MAI EXISTA VREUN COOLDOWN!! <br />
                                        BANII PE CARE II PREDATI UNUI MEMBRU AL CONDUCERII SUNT NERAMBURSABILI <br />
                                        PENTRU GRADELE MEDIC-PRIMAR+  E NECESARA IMPLICAREA DEOSEBITA IN ACTIVITATILE DEPARTAMENTULUI !!! <br />
                                        LA 2 SAPTAMANI DE PONTAJ PE ROȘU VETI PRIMI DOWN(pentru Medic Stagiar+) SAU OUT (pentru Asistent Medical) !!! <br />
                                        O DATA CU DOUBLE UP UL DE LA M500 LA M300 SUNTETI OBLIGATI SA DATI CERTIFICAT-UL SMULS in 3 SAPTAMANI. IN CAZ CONTRAR , DOWN LA M400 !! <br />
                                        MASINA PFISTER COMET SE POATE FOLOSII 1 LA 5 CADRE MEDICALE ON DUTY !!! <br />
                                        <br />
                                        MOTORUL LA JAF SE POATE FOLOSII DOAR DE LA GRADUL M200+ <br />
                                    </span>
                                </Disclosure.Panel>
                            </>
                        )}
                    </Disclosure>
                    <Disclosure as="div" className="mt-2 w-full">
                        {({ open }) => (
                            <>
                                <Disclosure.Button className="flex items-center w-full h-[5vh] justify-between rounded-lg bg-white dark:bg-[#f9731675] px-4 py-2 text-left text-sm font-medium hover:bg-orange-600 focus:outline-none focus-visible:ring focus-visible:ring-orange-600/75">
                                    <span className="textBold text-[1.1vw] text-black dark:text-white">Info BONUSURI</span>
                                    <ChevronUpIcon
                                        className={`${
                                            open ? 'rotate-180 transform' : ''
                                        } h-5 w-5 text-black dark:text-white`}
                                    />
                                </Disclosure.Button>
                                <Disclosure.Panel className="bg-white dark:bg-[#323232c1] textMedium px-4 pb-2 pt-4 text-sm text-black dark:text-white textMedium">
                                    <span className="textMedium text-[0.8vw] text-black dark:text-white">
                                        BONUSURI SAPTAMANALE:<br />
                                        -------------------- <br />
                                        1 Adeverinte = 5.000$	<br />	
                                        1 M.M.L.S = 7.000$	<br />
                                        -------------------- <br />
                                        1 Moto = 15.000$		<br />
                                        1 Admitere = 20.000$	<br />	
                                        1 Pilot = 20.000$		<br />
                                        1 S.M.U.L.S = 20.000$   <br />
                                        -------------------- <br />
                                        Conducere = 250.000$       <br />                                 					
                                        H.R. Sef = 150.000 $					<br />
                                        H.R Panel & Docs = 80.000 $					<br />
                                        H.R Panel = 50.000 $					<br />
                                        Coordonator JAF = 90.000 $					<br />
                                        Sef Sub Deparment (oricare) = 120.000 $ 		<br />			
                                        Adjunct Sub Departament (oricare) = 90.000 $		<br />			
                                    </span>
                                </Disclosure.Panel>
                            </>
                        )}
                    </Disclosure>
                    <Disclosure as="div" className="mt-2 w-full">
                        {({ open }) => (
                            <>
                                <Disclosure.Button className="flex items-center w-full h-[5vh] justify-between rounded-lg bg-white dark:bg-[#f9731675] px-4 py-2 text-left text-sm font-medium hover:bg-orange-600 focus:outline-none focus-visible:ring focus-visible:ring-orange-600/75">
                                    <span className="textBold text-[1.1vw] text-black dark:text-white">Amenzi DP</span>
                                    <ChevronUpIcon
                                        className={`${
                                            open ? 'rotate-180 transform' : ''
                                        } h-5 w-5 text-black dark:text-white`}
                                    />
                                </Disclosure.Button>
                                <Disclosure.Panel className="bg-white dark:bg-[#323232c1] textMedium px-4 pb-2 pt-4 text-sm text-black dark:text-white textMedium">
                                    <span className="textMedium text-[0.8vw] text-black dark:text-white">
                                        <table>
                                            <tr>
                                                <th>Nr</th>
                                                <th>Nume Sanctiune</th>
                                                <th>Suma Sanctiunii</th>
                                                <th>ASISTENT MEDICAL</th>
                                                <th>MEDIC STAGIAR</th>
                                                <th>MEDIC REZIDENT</th>
                                                <th>MEDIC SPECIALIST</th>
                                                <th>MEDIC PRIMAR</th>
                                            </tr>
                                            <tr>
                                                <th>I.</th>
                                                <th>Neascultarea gradului SUPERIOR</th>
                                                <th>-Amenda 175.000$</th>
                                                <th>175.000</th>
                                                <th>200.000</th>
                                                <th>250.000</th>
                                                <th>300.000</th>
                                                <th>350.000</th>
                                            </tr>
                                            <tr>
                                                <th>II.</th>
                                                <th>Neprezentare la sedinta fara invoire</th>
                                                <th>Faction Warn (fw)</th>
                                                <th>FW</th>
                                                <th>FW</th>
                                                <th>FW</th>
                                                <th>FW</th>
                                                <th>FW</th>
                                            </tr>
                                            <tr>
                                                <th>III.</th>
                                                <th>Comportamentul neadecvat al unui medic IC/OOC</th>
                                                <th>Amenda 200.000$</th>
                                                <th>200.000</th>
                                                <th>225.000</th>
                                                <th>275.000</th>
                                                <th>325.000</th>
                                                <th>375.000</th>
                                            </tr>
                                            <tr>
                                                <th>IV.</th>
                                                <th>Injurii / comportament neadecvat asupra unui pacient / civil</th>
                                                <th>-Amenda 250.000$</th>
                                                <th>250.000</th>
                                                <th>275.000</th>
                                                <th>325.000</th>
                                                <th>375.000</th>
                                                <th>425.000</th>
                                            </tr>
                                            <tr>
                                                <th>V.</th>
                                                <th>CEARTA / BATAIE intre COLEGI</th>
                                                <th>-Amenda 250.000$</th>
                                                <th>250.000</th>
                                                <th>275.000</th>
                                                <th>325.000</th>
                                                <th>375.000</th>
                                                <th>425.000</th>
                                            </tr>
                                            <tr>
                                                <th>VI.</th>
                                                <th>Folosirea autospecialelor necorespunzatoare gradului</th>
                                                <th>-Amenda 175.000$</th>
                                                <th>175.000</th>
                                                <th>200.000</th>
                                                <th>250.000</th>
                                                <th>300.000</th>
                                                <th>350.000</th>
                                            </tr>
                                            <tr>
                                                <th>VII.</th>
                                                <th>Iese de pe tura fara sa anunte</th>
                                                <th>-Amenda 110.000$</th>
                                                <th>110.000</th>
                                                <th>135.000</th>
                                                <th>185.000</th>
                                                <th>235.000</th>
                                                <th>285.000</th>
                                            </tr>
                                            <tr>
                                                <th>VIII.</th>
                                                <th>Fentare pontaj / Neprezentare la regrupare</th>
                                                <th>-Amenda 200.000$-Demitere</th>
                                                <th>200.000</th>
                                                <th>225.000</th>
                                                <th>275.000</th>
                                                <th>325.000</th>
                                                <th>375.000</th>
                                            </tr>
                                            <tr>
                                                <th>IX.</th>
                                                <th>Injurii/comportament neadecvat impotriva POLITIEI</th>
                                                <th>-Amenda 175.000$</th>
                                                <th>175.000</th>
                                                <th>200.000</th>
                                                <th>250.000</th>
                                                <th>300.000</th>
                                                <th>350.000</th>
                                            </tr>
                                            <tr>
                                                <th>X.</th>
                                                <th>Vorbit necorespunzator pe statie</th>
                                                <th>-Amenda 175.000$</th>
                                                <th>175.000</th>
                                                <th>200.000</th>
                                                <th>250.000</th>
                                                <th>300.000</th>
                                                <th>350.000</th>
                                            </tr>
                                            <tr>
                                                <th>XI.</th>
                                                <th>Nepreluarea apelurilor</th>
                                                <th>-Amenda 150.000$</th>
                                                <th>150.000</th>
                                                <th>175.000</th>
                                                <th>225.000</th>
                                                <th>275.000</th>
                                                <th>325.000</th>
                                            </tr>
                                            <tr>
                                                <th>XII.</th>
                                                <th>Prezentare la APEL / BK fara echipament</th>
                                                <th>-Amenda 150.000$</th>
                                                <th>150.000</th>
                                                <th>175.000</th>
                                                <th>225.000</th>
                                                <th>275.000</th>
                                                <th>325.000</th>
                                            </tr>
                                            <tr>
                                                <th>XIII.</th>
                                                <th>Nerespectarea coordonatorului la jaf</th>
                                                <th>-Amenda 200.000$</th>
                                                <th>200.000</th>
                                                <th>225.000</th>
                                                <th>275.000</th>
                                                <th>325.000</th>
                                                <th>375.000</th>
                                            </tr>
                                            <tr>
                                                <th>XIV.</th>
                                                <th>Scoaterea masinii personale ON-DUTY</th>
                                                <th>-Amenda 130.000$</th>
                                                <th>130.000</th>
                                                <th>155.000</th>
                                                <th>205.000</th>
                                                <th>255.000</th>
                                                <th>301.000</th>
                                            </tr>
                                            <tr>
                                                <th>XV.</th>
                                                <th>Modificare uniforma / Tinuta necorespunzatoare</th>
                                                <th>-Amenda 175.000$</th>
                                                <th>175.000</th>
                                                <th>200.000</th>
                                                <th>250.000</th>
                                                <th>300.000</th>
                                                <th>350.000</th>
                                            </tr>
                                            <tr>
                                                <th>XVI.</th>
                                                <th>Deranjarea regruparii</th>
                                                <th>-Amenda 200.000-250.000$</th>
                                                <th>200.000-250.000</th>
                                                <th>225.000-275.000</th>
                                                <th>275.000-325.000</th>
                                                <th>325.000-375.000</th>
                                                <th>375.000-425.000</th>
                                            </tr>
                                            <tr>
                                                <th>XVII.</th>
                                                <th>Folosire coduri de asistenta ( BK4 / BK 0)</th>
                                                <th>-Amenda 200.000$</th>
                                                <th>200.000</th>
                                                <th>225.000</th>
                                                <th>275.000</th>
                                                <th>325.000</th>
                                                <th>375.000</th>
                                            </tr>
                                            <tr>
                                                <th>XVIII.</th>
                                                <th>Greseli pe docs membrii HR</th>
                                                <th>-Amenda 300.000$</th>
                                                <th>300.000</th>
                                                <th>325.000</th>
                                                <th>375.000</th>
                                                <th>425.000</th>
                                                <th>475.000</th>
                                            </tr>
                                            <tr>
                                                <th>XIX.</th>
                                                <th>Neprezentarea la controalele ISULS, DSLS sau MMLS</th>
                                                <th>-Amenda 125.000$</th>
                                                <th>125.000</th>
                                                <th>150.000</th>
                                                <th>200.000</th>
                                                <th>250.000</th>
                                                <th>300.000</th>
                                            </tr>
                                            <tr>
                                                <th>XX.</th>
                                                <th>Neprezentarea la antrenamentele anunțate</th>
                                                <th>-Amenda 75.000$</th>
                                                <th>75.000</th>
                                                <th>100.000</th>
                                                <th>150.000</th>
                                                <th>200.000</th>
                                                <th>250.000</th>
                                            </tr>
                                            <tr>
                                                <th>XXI.</th>
                                                <th>Prezenta pe discord cu duty pornit</th>
                                                <th>-Amenda 225.000$</th>
                                                <th>225.000</th>
                                                <th>250.000</th>
                                                <th>300.000</th>
                                                <th>350.000</th>
                                                <th>400.000</th>
                                            </tr>
                                            <tr>
                                                <th>XXII.</th>
                                                <th>Neanunțarea poliției în cazul în care sunt mai puțin de 3 medici pentru jaf</th>
                                                <th>-Amenda 200.000$</th>
                                                <th>200.000</th>
                                                <th>225.000</th>
                                                <th>275.000</th>
                                                <th>325.000</th>
                                                <th>375.000</th>
                                            </tr>
                                            <tr>
                                                <th>XXIII.</th>
                                                <th>Greseala in sustinerea testelor</th>
                                                <th>- Amenda 200.000$</th>
                                                <th>200.000</th>
                                                <th>225.000</th>
                                                <th>275.000</th>
                                                <th>325.000</th>
                                                <th>375.000</th>
                                            </tr>
                                            <tr>
                                                <th>XXIV.</th>
                                                <th>Greșeală fiind membru Conducere</th>
                                                <th>- Amenda 2.500.000$</th>
                                                <th>-</th>
                                                <th>-</th>
                                                <th>-</th>
                                                <th>-</th>
                                                <th>-</th>
                                            </tr>
                                            <tr>
                                                <th>XXV.</th>
                                                <th>Divulgare de informatii din interiorul departamentului</th>
                                                <th>-Demitere+Ban+Blacklist</th>
                                                <th>Demitere+Ban+Blacklist</th>
                                                <th>Demitere+Ban+Blacklist</th>
                                                <th>Demitere+Ban+Blacklist</th>
                                                <th>Demitere+Ban+Blacklist</th>
                                                <th>Demitere+Ban+Blacklist</th>
                                            </tr>
                                            <tr>
                                                <th>XXVI.</th>
                                                <th>Coruptie</th>
                                                <th>-Demitere+Ban+Blacklist</th>
                                                <th>Demitere+Ban+Blacklist</th>
                                                <th>Demitere+Ban+Blacklist</th>
                                                <th>Demitere+Ban+Blacklist</th>
                                                <th>Demitere+Ban+Blacklist</th>
                                                <th>Demitere+Ban+Blacklist</th>
                                            </tr>
                                            <tr>
                                                <th>XXVII.</th>
                                                <th>Neprezentare la adeverinte anuntate</th>
                                                <th>- Amenda 200.000$</th>
                                                <th>-</th>
                                                <th>-</th>
                                                <th>-</th>
                                                <th>200.000</th>
                                                <th>200.000</th>
                                            </tr>
                                            <tr>
                                                <th>XXVIII.</th>
                                                <th>Nerespectare Roleplay Medical</th>
                                                <th>- Avertisment scris</th>
                                                <th>-</th>
                                                <th>-</th>
                                                <th>-</th>
                                                <th>-</th>
                                                <th>-</th>
                                            </tr>
                                            <tr>
                                                <th>XXIX.</th>
                                                <th>Vorbit necorespunzator la apel</th>
                                                <th>- Avertisment scris/Amenda</th>
                                                <th>-</th>
                                                <th>-</th>
                                                <th>-</th>
                                                <th>-</th>
                                                <th>-</th>
                                            </tr>
                                        </table>
                                    </span>
                                </Disclosure.Panel>
                            </>
                        )}
                    </Disclosure>
                </div>
            </div>
        </div>
    )
}

export default InfoPage;